// Requires: min 10 chars, at least one uppercase, one lowercase, one digit.
// Special characters are encouraged (shown in strength indicator) but not mandatory,
// per NIST SP 800-63B — length is a stronger security factor than forced symbols.
export const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{10,}$/

export interface PasswordStrengthLabels {
    minLength: string
    uppercase: string
    lowercase: string
    number: string
    special: string
}

export function getPasswordStrength(
    password: string,
    labels: PasswordStrengthLabels,
) {
    const checks = [
        { label: labels.minLength, met: password.length >= 10 },
        { label: labels.uppercase, met: /[A-Z]/.test(password) },
        { label: labels.lowercase, met: /[a-z]/.test(password) },
        { label: labels.number, met: /\d/.test(password) },
        { label: labels.special, met: /[^A-Za-z\d]/.test(password) },
    ]
    const score = checks.filter((c) => c.met).length
    return { checks, score }
}
